import React, { useState, useEffect } from "react";
import { useI18n } from "../i18n/I18nProvider";

// Define the colors based on the image's palette
const EkatraBlue = "#033049";
const EkatraBackground = "#fdf7ef";

const AudioSvg = () => (
  <svg
    className="w-full h-full"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.75 59.4935C18.75 53.2018 23.7868 48.1011 30 48.1011C36.2132 48.1011 41.25 53.2018 41.25 59.4935C41.25 65.7851 36.2132 70.8859 30 70.8859C23.7868 70.8859 18.75 65.7851 18.75 59.4935Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M66.5975 7.23439C68.4715 6.34138 69.276 4.0791 68.394 2.18143C67.512 0.283759 65.278 -0.530671 63.404 0.362341L23.8346 19.219C15.1574 19.6702 9.7283 21 5.85785 24.9193C5.96046e-07 30.8514 0 40.399 0 59.4937C0 78.5884 5.96046e-07 88.1362 5.85785 94.0678C11.7157 100 21.1438 100 40 100H60C78.856 100 88.2845 100 94.142 94.0678C100 88.1362 100 78.5884 100 59.4937C100 40.399 100 30.8513 94.142 24.9193C88.2845 18.9874 78.856 18.9874 60 18.9874H41.935L66.5975 7.23439ZM30 40.5063C19.6446 40.5063 11.25 49.0071 11.25 59.4937C11.25 69.9803 19.6446 78.481 30 78.481C40.3555 78.481 48.75 69.9803 48.75 59.4937C48.75 49.0071 40.3555 40.5063 30 40.5063ZM53.75 44.3038C53.75 42.2066 55.429 40.5063 57.5 40.5063H85C87.071 40.5063 88.75 42.2066 88.75 44.3038C88.75 46.401 87.071 48.1013 85 48.1013H57.5C55.429 48.1013 53.75 46.401 53.75 44.3038ZM57.5 55.6962C55.429 55.6962 53.75 57.3965 53.75 59.4937C53.75 61.5909 55.429 63.2911 57.5 63.2911H85C87.071 63.2911 88.75 61.5909 88.75 59.4937C88.75 57.3965 87.071 55.6962 85 55.6962H57.5ZM53.75 74.6835C53.75 72.5863 55.429 70.8861 57.5 70.8861H85C87.071 70.8861 88.75 72.5863 88.75 74.6835C88.75 76.7808 87.071 78.481 85 78.481H57.5C55.429 78.481 53.75 76.7808 53.75 74.6835Z"
      fill="currentColor"
    />
  </svg>
);

const LanguageSvg = () => (
  <svg
    className="w-full h-full"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M66.6666 50.9844L74.5104 66.6666H58.8229L62.1354 60.0521L66.6666 50.9844ZM100 8.33335V91.6667C100 96.2692 96.2692 100 91.6667 100H8.33335C3.73083 100 0 96.2692 0 91.6667V8.33335C0 3.73095 3.73095 0 8.33335 0H91.6667C96.2691 0 100 3.73095 100 8.33335ZM91.2292 81.4688L70.3959 39.8021C68.9651 36.9314 64.9632 36.686 63.1925 39.3605C63.0985 39.5023 63.0134 39.6498 62.9375 39.8021L56.0729 53.5417C51.6572 52.6768 47.4696 50.9031 43.776 48.3333C49.533 41.8157 53.095 33.6531 53.9583 25H62.5C65.7075 25 67.7122 21.5278 66.1085 18.75C65.3641 17.4608 63.9886 16.6667 62.5 16.6667H41.6667V12.5C41.6667 9.29249 38.1944 7.28783 35.4167 8.89154C34.1275 9.63588 33.3333 11.0114 33.3333 12.5V16.6667H12.5C9.29249 16.6667 7.28783 20.1389 8.89154 22.9167C9.63588 24.2058 11.0114 25 12.5 25H45.5625C44.7359 31.5743 41.9606 37.7508 37.5938 42.7344C35.7438 40.5747 34.1692 38.1936 32.9062 35.6458C31.3904 32.8191 27.3831 32.6933 25.6929 35.4194C24.9567 36.6069 24.8647 38.0845 25.4479 39.3542C27.0427 42.57 29.0376 45.5712 31.3854 48.2865C25.8357 52.1235 19.247 54.175 12.5 54.1667C9.29249 54.1667 7.28783 57.6389 8.89154 60.4167C9.63588 61.7059 11.0113 62.5001 12.5 62.5C21.5455 62.5096 30.3457 59.5592 37.5573 54.099C41.9209 57.4343 46.913 59.8542 52.2344 61.2135L42.1042 81.4688C40.6688 84.3395 42.8793 87.6875 46.0831 87.4952C47.57 87.4059 48.8964 86.5302 49.5625 85.1979L54.6562 75H78.6771L83.7709 85.1979C85.2062 88.0686 89.2109 88.309 90.9794 85.6306C91.8001 84.3876 91.8953 82.8011 91.2292 81.4688Z"
      fill="currentColor"
    />
  </svg>
);

const MobileSvg = () => (
  <svg
    className="w-full h-full"
    viewBox="0 0 70 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.7273 0C5.70739 0 0 5.60547 0 12.5V87.5C0 94.3945 5.70739 100 12.7273 100H57.2727C64.2926 100 70 94.3945 70 87.5V12.5C70 5.60547 64.2926 0 57.2727 0H12.7273ZM28.6364 84.375H41.3636C43.1136 84.375 44.5455 85.7812 44.5455 87.5C44.5455 89.2188 43.1136 90.625 41.3636 90.625H28.6364C26.8864 90.625 25.4545 89.2188 25.4545 87.5C25.4545 85.7812 26.8864 84.375 28.6364 84.375Z"
      fill="currentColor"
    />
  </svg>
);

const BookSvg = () => (
  <svg
    className="w-full h-full"
    viewBox="0 0 82 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M75.2702 16.6667C74.7953 16.5706 74.3685 16.3149 74.062 15.9429C73.7555 15.5708 73.5881 15.1053 73.5882 14.625V8.33333C73.5882 6.1232 72.7021 4.00358 71.125 2.44078C69.5478 0.877974 67.4086 0 65.1781 0L12.6151 0C9.26938 0 6.06068 1.31696 3.69488 3.66116C1.32909 6.00537 0 9.18479 0 12.5V87.5C0 90.8152 1.32909 93.9946 3.69488 96.3388C6.06068 98.683 9.26938 100 12.6151 100H73.5882C75.8187 100 77.9578 99.122 79.535 97.5592C81.1122 95.9964 81.9983 93.8768 81.9983 91.6667V25C82.038 23.0504 81.3864 21.1488 80.1571 19.6262C78.9277 18.1035 77.1984 17.0563 75.2702 16.6667ZM63.0756 55.2083C63.0628 55.41 62.9934 55.604 62.8752 55.7686C62.757 55.9332 62.5947 56.0618 62.4066 56.1398C62.2185 56.2178 62.0122 56.2422 61.8109 56.2101C61.6096 56.178 61.4214 56.0908 61.2674 55.9583L53.3199 48.0417C53.1118 47.8572 52.8423 47.7552 52.563 47.7552C52.2837 47.7552 52.0143 47.8572 51.8061 48.0417L43.8586 55.9583C43.6828 56.0696 43.4785 56.1288 43.2699 56.1288C43.0612 56.1288 42.857 56.0696 42.6812 55.9583C42.4931 55.877 42.3332 55.7429 42.2211 55.5727C42.109 55.4024 42.0497 55.2033 42.0504 55V23.9583C42.0504 23.6821 42.1612 23.4171 42.3583 23.2218C42.5555 23.0264 42.8229 22.9167 43.1017 22.9167H62.0243C62.3032 22.9167 62.5706 23.0264 62.7677 23.2218C62.9649 23.4171 63.0756 23.6821 63.0756 23.9583V55.2083ZM65.1781 15.4583C65.2027 15.6084 65.1938 15.762 65.1521 15.9083C65.1104 16.0546 65.0368 16.1901 64.9367 16.3052C64.8365 16.4204 64.7121 16.5124 64.5722 16.5748C64.4323 16.6373 64.2803 16.6686 64.1269 16.6667H12.6151C11.4999 16.6667 10.4303 16.2277 9.64171 15.4463C8.85311 14.6649 8.41008 13.6051 8.41008 12.5C8.41008 11.3949 8.85311 10.3351 9.64171 9.55372C10.4303 8.77232 11.4999 8.33333 12.6151 8.33333H64.1269C64.4057 8.33333 64.6731 8.44308 64.8702 8.63843C65.0674 8.83378 65.1781 9.09873 65.1781 9.375V15.4583Z"
      fill="currentColor"
    />
  </svg>
);

const UsersSvg = () => (
  <svg
    className="w-full h-full"
    viewBox="0 0 100 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M50 41.2941C58.5132 41.2941 66.2305 44.137 71.8845 48.1168C77.2641 51.9035 81.8182 57.5278 81.8182 63.5796C81.8182 66.9034 80.4155 69.6545 78.2023 71.704C76.12 73.6325 73.4014 74.8828 70.6014 75.738C65.0045 77.448 57.6377 78 50 78C42.3623 78 34.9956 77.448 29.3986 75.738C26.5986 74.8828 23.8798 73.6325 21.7975 71.704C19.5846 69.6545 18.1818 66.9034 18.1818 63.5796C18.1818 57.5278 22.736 51.9035 28.1152 48.1168C33.7693 44.137 41.4868 41.2941 50 41.2941ZM81.8182 45.8824C86.5659 45.8824 90.8741 47.463 94.0605 49.7062C96.9723 51.7558 100 55.1676 100 59.3195C100 61.6925 98.9786 63.6613 97.4559 65.0717C96.0636 66.361 94.3432 67.1158 92.7773 67.5943C90.6405 68.2468 88.1177 68.5813 85.4995 68.7281C86.0555 67.1461 86.3636 65.4241 86.3636 63.5796C86.3636 56.5349 82.0045 50.555 77.1268 46.4008C78.6209 46.0673 80.1936 45.8824 81.8182 45.8824ZM18.1818 45.8824C19.8061 45.8824 21.3791 46.0673 22.8732 46.4008C17.9954 50.555 13.6364 56.5349 13.6364 63.5796C13.6364 65.4241 13.9447 67.1461 14.5003 68.7281C11.8822 68.5813 9.35946 68.2468 7.22277 67.5943C5.65659 67.1158 3.93632 66.361 2.54414 65.0717C1.02123 63.6613 0 61.6925 0 59.3195C0 55.1676 3.02782 51.7558 5.93941 49.7062C9.12582 47.463 13.4341 45.8824 18.1818 45.8824ZM79.5455 18.3529C85.8214 18.3529 90.9091 23.4885 90.9091 29.8235C90.9091 36.1585 85.8214 41.2941 79.5455 41.2941C73.2695 41.2941 68.1818 36.1585 68.1818 29.8235C68.1818 23.4885 73.2695 18.3529 79.5455 18.3529ZM20.4545 18.3529C26.7305 18.3529 31.8182 23.4885 31.8182 29.8235C31.8182 36.1585 26.7305 41.2941 20.4545 41.2941C14.1786 41.2941 9.09091 36.1585 9.09091 29.8235C9.09091 23.4885 14.1786 18.3529 20.4545 18.3529ZM50 0C60.0414 0 68.1818 8.21689 68.1818 18.3529C68.1818 28.489 60.0414 36.7059 50 36.7059C39.9585 36.7059 31.8182 28.489 31.8182 18.3529C31.8182 8.21689 39.9585 0 50 0Z"
      fill="currentColor"
    />
  </svg>
);

const RoboSvg = () => (
  <svg
    className="w-full h-full"
    viewBox="0 0 76 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M61.75 4.7619H42.75V2C42.75 0.895432 41.8546 0 40.75 0H35.25C34.1454 0 33.25 0.89543 33.25 2V4.7619H14.25C6.37996 4.7619 0 11.1579 0 19.0476V33.3333C0 46.4829 10.6333 57.1429 23.75 57.1429H52.25C65.3667 57.1429 76 46.4829 76 33.3333V19.0476C76 11.1579 69.6203 4.7619 61.75 4.7619ZM33.25 30.9524C33.25 34.8973 30.0599 38.0952 26.125 38.0952C22.19 38.0952 19 34.8973 19 30.9524C19 27.0075 22.19 23.8095 26.125 23.8095C30.0599 23.8095 33.25 27.0075 33.25 30.9524ZM57 30.9524C57 34.8973 53.8099 38.0952 49.875 38.0952C45.9401 38.0952 42.75 34.8973 42.75 30.9524C42.75 27.0075 45.9401 23.8095 49.875 23.8095C53.8099 23.8095 57 27.0075 57 30.9524ZM10 100C4.47715 100 -0.133714 95.446 1.29295 90.1106C5.6368 73.8656 20.4251 61.9048 38 61.9048C55.575 61.9048 70.3632 73.8656 74.7071 90.1106C76.1337 95.446 71.5229 100 66 100H10Z"
      fill="currentColor"
    />
  </svg>
);

export default function Features() {
  const { t } = useI18n();

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const locale =
    typeof window !== "undefined"
      ? localStorage.getItem("app_locale") || "en"
      : "en";

  const isEnglish = locale === "en";

  return (
    <section
      id="features"
      className="py-12 sm:py-16 lg:py-12 px-4 sm:px-6 lg:px-8 bg-[#fdf7ef]"
    >
      <div className="text-center mb-16">
        <div className="relative md:inline-block">
          <h2
            className={`font-lexend font-extralight text-[20px] sm:text-[32px] md:text-[40px] lg:text-[54px]  text-[${EkatraBlue}]`}
          >
            {t("features.heading.prefix")}{" "}
            <span className={`font-bold`}>
              {t("features.heading.highlight1")}
            </span>{" "}
            {t("features.heading.connector")}
            <br />
            {t("features.heading.line2Prefix")}{" "}
            <span className={`font-bold`}>
              {t("features.heading.highlight2")}
            </span>
          </h2>

          {/* SVG line positioned under "Features & Capabilities" */}
          {isEnglish ? (
           <>
          <svg
            className="absolute top-[16px] left-[23%] sm:top-[36px] sm:left-[150px] md:top-[48px] md:left-[100px] lg:top-[62px] lg:left-[140px] lg:w-[620px] md:w-[480px] sm:w-[400px] w-[250px]"
            height="31"
            viewBox="0 0 643 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M637.501 19.1877L553.054 10.0833C521.884 6.72282 490.363 9.02788 460.014 16.8872C430.835 24.4433 400.565 26.8677 370.556 24.0522L203.355 8.36494C179.557 6.13216 155.569 7.06536 132.016 11.1401C101.239 16.4649 69.7715 16.4157 39.0109 10.9946L5.00085 5.00098"
              stroke="#F1AF38"
              stroke-width="10"
              stroke-linecap="round"
            />
          </svg>

          <svg
            className="absolute lg:top-[150px] md:top-[115px] sm:top-[90px] left-[32%] top-[50px] sm:left-[210px] md:left-[160px] lg:left-[290px] lg:w-[620px] md:w-[480px] sm:w-[400px] w-[250px]"
            width="620"
            height="28"
            viewBox="0 0 565 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.00031 19.2754L82.9198 11.9979C108.098 9.64638 133.489 11.268 158.163 16.8033C185.972 23.042 214.667 24.3036 242.917 20.5297L316.036 10.7616C383.13 1.79838 451.208 3.30121 517.841 15.2164L560 22.7554"
              stroke="#F1AF38"
              stroke-width="10"
              stroke-linecap="round"
            />
          </svg>

          <svg
            style={{
              position: "absolute",
              top: "50px",
              left: "900px",
            }}
            width="74"
            height="68"
            viewBox="0 0 74 68"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.1737 11.5L5.00122 42M68.1737 5L21.6737 49.5M37.6737 62.5L68.1737 49.5"
              stroke="#F1AF38"
              stroke-width="10"
              stroke-linecap="round"
            />
          </svg>
          </>
) : (
  /* FALLBACK SVG for non-English */
  <>
  <svg
            className={`absolute sm:top-[36px] sm:left-[150px] md:top-[48px] md:left-[100px] lg:top-[62px] lg:left-[10px] lg:w-[620px] md:w-[480px] sm:w-[400px] w-[250px] ${isMobile ? "top-[16px] left-[19%]" : "top-[16px] left-[23%]"}`}
            height="31"
            viewBox="0 0 643 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M637.501 19.1877L553.054 10.0833C521.884 6.72282 490.363 9.02788 460.014 16.8872C430.835 24.4433 400.565 26.8677 370.556 24.0522L203.355 8.36494C179.557 6.13216 155.569 7.06536 132.016 11.1401C101.239 16.4649 69.7715 16.4157 39.0109 10.9946L5.00085 5.00098"
              stroke="#F1AF38"
              stroke-width="10"
              stroke-linecap="round"
            />
          </svg>
  </>
)}
        </div>
      </div>
      {/* ======= Bento Grid Layout ======= */}
      <div className="max-w-6xl mx-auto">
        {/* Grid Container - 2 columns on desktop, 1 on mobile */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5 lg:gap-6">
          {/* Column 1 - Left Side */}
          <div className="flex flex-col gap-4 sm:gap-5 lg:gap-6">
            {/* AI-Generated Audio Summaries - Tall Card */}
            <div className="bg-[#004668] text-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-10 min-h-[320px] sm:min-h-[380px] lg:min-h-[420px] flex flex-col justify-between shadow-md">
              <div className="flex items-start justify-between gap-6">
                <h3 className="font-lexend font-semibold text-xl sm:text-2xl md:text-3xl lg:text-[32px] leading-tight max-w-[260px]">
                  {t("features.cards.audio.titleLine1")}
                  <br />
                  {t("features.cards.audio.titleLine2")}
                </h3>
                <div className="w-10 h-10 sm:w-12 sm:h-12 lg:w-14 lg:h-14 flex items-center justify-center text-[#FDF7EF]">
                  <AudioSvg />
                </div>
              </div>
              <p className="mt-6 text-[13px] sm:text-sm md:text-base leading-relaxed text-[#E6F0F5]">
                {t("features.cards.audio.description")}
              </p>
            </div>

            {/* Mobile Friendly - Short Card */}
            <div className="bg-[#F1AF38] rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-10 min-h-[220px] sm:min-h-[240px] lg:min-h-[260px] flex flex-col justify-between shadow-md">
              <div className="flex items-start justify-between gap-6">
                <h3 className="font-lexend font-semibold text-xl sm:text-2xl md:text-3xl lg:text-[32px] leading-tight max-w-[220px] text-[#004668]">
                  {t("features.cards.mobile.titleLine1")}
                  <br />
                  {t("features.cards.mobile.titleLine2")}
                </h3>
                <div className="w-10 h-10 sm:w-12 sm:h-12 lg:w-14 lg:h-14 flex items-center justify-center text-[#004668]">
                  <MobileSvg />
                </div>
              </div>
              <p className="mt-6 text-[13px] sm:text-sm md:text-base leading-relaxed text-[#004668]/90">
                {t("features.cards.mobile.description")}
              </p>
            </div>

            {/* Intelligent Narration - Medium Card */}
            <div className="bg-[#004668] text-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-10 min-h-[260px] sm:min-h-[300px] lg:min-h-[320px] flex flex-col justify-between shadow-md">
              <div className="flex items-start justify-between gap-6">
                <h3 className="font-lexend font-semibold text-xl sm:text-2xl md:text-3xl lg:text-[32px] leading-tight max-w-[240px]">
                  {t("features.cards.narration.titleLine1")}
                  <br />
                  {t("features.cards.narration.titleLine2")}
                </h3>
                <div className="w-10 h-10 sm:w-12 sm:h-12 lg:w-14 lg:h-14 flex items-center justify-center text-[#FDF7EF]">
                  <RoboSvg />
                </div>
              </div>
              <p className="mt-6 text-[13px] sm:text-sm md:text-base leading-relaxed text-[#E6F0F5]">
                {t("features.cards.narration.description")}
              </p>
            </div>
          </div>

          {/* Column 2 - Right Side */}
          <div className="flex flex-col gap-4 sm:gap-5 lg:gap-6">
            {/* Multilingual Access - Short Card */}
            <div className="bg-[#F1AF38] rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-10 min-h-[220px] sm:min-h-[240px] lg:min-h-[260px] flex flex-col justify-between shadow-md">
              <div className="flex items-start justify-between gap-6">
                <h3 className="font-lexend font-semibold text-xl sm:text-2xl md:text-3xl lg:text-[32px] leading-tight max-w-[260px] text-[#004668]">
                  {t("features.cards.multilingual.titleLine1")}
                  <br />
                  {t("features.cards.multilingual.titleLine2")}
                </h3>
                <div className="w-10 h-10 sm:w-12 sm:h-12 lg:w-14 lg:h-14 flex items-center justify-center text-[#004668]">
                  <LanguageSvg />
                </div>
              </div>
              <p className="mt-6 text-[13px] sm:text-sm md:text-base leading-relaxed text-[#004668]/90">
                {t("features.cards.multilingual.description")}
              </p>
            </div>

            {/* Expertly Curated Library - Medium Card */}
            <div className="bg-[#004668] text-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-10 min-h-[260px] sm:min-h-[300px] lg:min-h-[320px] flex flex-col justify-between shadow-md">
              <div className="flex items-start justify-between gap-6">
                <h3 className="font-lexend font-semibold text-xl sm:text-2xl md:text-3xl lg:text-[32px] leading-tight max-w-[260px]">
                  {t("features.cards.curated.titleLine1")}
                  <br />
                  {t("features.cards.curated.titleLine2")}
                </h3>
                <div className="w-10 h-10 sm:w-12 sm:h-12 lg:w-14 lg:h-14 flex items-center justify-center text-[#FDF7EF]">
                  <BookSvg />
                </div>
              </div>
              <p className="mt-6 text-[13px] sm:text-sm md:text-base leading-relaxed text-[#E6F0F5]">
                {t("features.cards.curated.description")}
              </p>
            </div>

            {/* Learning Community - Tall Card */}
            <div className="bg-[#F1AF38] rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-10 min-h-[280px] sm:min-h-[380px] lg:min-h-[420px] flex flex-col justify-between shadow-md">
              <div className="flex items-start justify-between gap-6">
                <h3 className="font-lexend font-semibold text-xl sm:text-2xl md:text-3xl lg:text-[32px] leading-tight max-w-[240px] text-[#004668]">
                  {t("features.cards.community.titleLine1")}
                  <br />
                  {t("features.cards.community.titleLine2")}
                </h3>
                <div className="w-10 h-10 sm:w-12 sm:h-12 lg:w-14 lg:h-14 flex items-center justify-center text-[#004668]">
                  <UsersSvg />
                </div>
              </div>
              <p className="mt-6 text-[13px] sm:text-sm md:text-base leading-relaxed text-[#004668]/90">
                {t("features.cards.community.description")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
